import {css} from 'lit';
export const styles = css`.critical-action-list{display:flex;flex-direction:column;gap:.75rem}`;
export default styles;
